export enum HawkerLoadForm {
  HawkerLoadTooltip = 'hpLT',
  Load = 'imvb',
}

export enum HawkerLoadFormTips {
  LoadColTip = 'jfbL',
}
